import { render, staticRenderFns } from "./research-menu.vue?vue&type=template&id=4b09e2b7&scoped=true"
import script from "./research-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./research-menu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09e2b7",
  null
  
)

export default component.exports